import { RouteObject } from 'react-router-dom';
import { RoutesEnum } from '~/constants/enums';
import FeatureListing from '~/pages/FeatureListing';
import FeatureCheckout from '~/pages/FeatureListing/Checkout';

const routes: RouteObject[] = [
  { index: true, element: <FeatureListing /> },
  {
    path: `:featureKey/${RoutesEnum.CHECKOUT}`,
    element: <FeatureCheckout />,
  },
];

export default routes;
